/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
import { LogLevel } from '@azure/msal-browser';

const NON_PROD_CLIENT_ID = 'd5966df2-b8be-4d32-9077-df7a212d4481';
const PROD_CLIENT_ID = '7700b0be-2336-4e27-b16f-2ccc10501e42';
/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */

// The host can be qa-book.lifestance.com, book.lifestance.com, or localhost:3000
// extract the env from the url, book being prod, qa-book being qa, perf-book being perf, and localhost being dev
// just need prod and non prod
const host = window?.location.host;
const env = host.includes('qa-book')
  || host.includes('localhost')
  || host.includes('perf-book')
  || host.includes('dev-book')
  || host.includes('uat-book')
  || host.includes('uat-legacy')
  ? 'NONPROD'
  : 'PROD';

console.log('SETTING CLIENT FOR ENV:', env);
const clientId = env === 'NONPROD' ? NON_PROD_CLIENT_ID : PROD_CLIENT_ID;

export const msalConfig = {
  auth: {
    clientId,
    authority: 'https://login.microsoftonline.com/34b5b6f0-9d22-40b1-b9be-bd425b21d6d3',
    redirectUri: `https://${window?.location.host}/admin` || 'https://localhost:3000/admin',
  },
  cache: {
    cacheLocation: 'sessionStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Info:
            console.info(message);
            break;
          case LogLevel.Verbose:
            console.debug(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
          default:
            break;
        }
      },
    },
  },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: ['User.Read'],
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
};
